import React from 'react'
import { withRouter } from 'react-router'
import { renderRoutes } from 'react-router-config'

import Cookies from 'js-cookie'

import { USER_TYPE_DEFAULT } from 'src/constants'
import {
  carePortalRoutes,
  deliveryManagerRoutes,
  rootAdminRoutes,
  securedEmailRoutes
} from 'src/routes'

import MaintenancePage from './MaintenancePage'

const getRoutes = (location = {}) => {
  if (location.pathname.startsWith('/secured-email/')) {
    return securedEmailRoutes
  }
  const cookies = Cookies
  const isDeliveryRootAdmin = Boolean(+cookies?.get('isDeliveryRootAdmin'))
  const userType = +cookies?.get('user_type') || USER_TYPE_DEFAULT

  if (userType === USER_TYPE_DEFAULT) {
    return carePortalRoutes
  } else if (isDeliveryRootAdmin) {
    return deliveryManagerRoutes
  } else {
    return rootAdminRoutes
  }
}

const Root = ({ location = {}, maintenance = false }) => {
  const routes = getRoutes(location)

  return maintenance ? <MaintenancePage /> : renderRoutes(routes)
}

export default withRouter(Root)
